import React from 'react'
import MyWalletVirtualCards from 'src/app/MyWallet/MyWalletVirtualCards'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { myWalletVirtualCardsRouteProps } from 'src/navigation/routeProps'

const MyWalletVirtualCardsAppRoute: AppRoute = {
  id: AppLocation.MyWalletVirtualCards,
  routeProps: myWalletVirtualCardsRouteProps,
  component: <MyWalletVirtualCards />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default MyWalletVirtualCardsAppRoute
